import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  getList: ['exerciseId', 'scope', 'pageIndex', 'pageSize'],
  getListSuccess: ['list', 'total', 'query'],
  getListFailed: null,
  exerciseNext: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const DEFAULT_PAGEING_SIZE = 20;
const INITIAL_STATE = {
  list: [],
  total: 0,
  pageIndex: 1,
  pageSize: DEFAULT_PAGEING_SIZE,
  enrollCount: 0,
  config: {},
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.GET_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    list: action.list,
    total: action.total,
    pageSize:
      (action.query?.totleCount ?? 1) >
      (action.query?.pageSize ?? DEFAULT_PAGEING_SIZE)
        ? action.query?.pageSize ?? DEFAULT_PAGEING_SIZE
        : (action.query?.totlePageCount ?? 1) * DEFAULT_PAGEING_SIZE,
  }),
  [Type.EXERCISE_NEXT]: (state = INITIAL_STATE) => ({
    ...state,
    pageIndex: 1,
    pageSize:
      DEFAULT_PAGEING_SIZE * (state.pageSize / DEFAULT_PAGEING_SIZE + 1),
  }),
});
